import React from 'react'
import img2038 from '../components/images/lflipkart.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2038} alt='flipkart' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Flipkart Listing Services
                    </h2>
                    <p>Enhance your Flipkart presence with our expert listing services designed to maximize product visibility and drive sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b> Create and optimize detailed product listings with high-quality images and accurate descriptions to attract potential customers. </li>
                <li><b>•	Advertising Campaign:</b>Develop and execute targeted ad campaigns to increase product visibility and maximize ROI on Flipkart. </li>
                <li><b>•	Coupons:</b>Set up and manage discount coupons to incentivize purchases and boost customer engagement. </li>
                <li><b>•	Brand Registry:</b>Assist in registering your brand on Flipkart to safeguard your brand identity and enhance customer trust. </li>
                <li><b>•	Brand Approval:</b>Simplify the process for getting your brand approved, ensuring compliance with Flipkart’s requirements. </li>
                <li><b>•	Category Approval:</b> Ensure your products are listed in the correct categories to improve discoverability and sales. </li>
                <li><b>•	Account Health:</b> Monitor and maintain the overall health of your Flipkart seller account, ensuring compliance with platform policies. </li>
                <li><b>•	Order Processing:</b> Efficiently manage the entire order fulfillment process from receipt to delivery, ensuring timely customer service. </li>
                <li><b>•	Payment Reconciliation:</b> Oversee payment processing, ensuring accurate transaction records and resolving any discrepancies promptly. </li>
                <li><b>•	Keyword Optimization:</b> Optimize your product listings with strategic keyword use to improve search rankings and visibility. </li>
                <li><b>•	Basic Training:</b>Provide essential training to equip your team with the knowledge to manage your Flipkart account effectively. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to enhance sales, including effective promotions and advertising optimization.</li>
            </ul>
        </>
    )
}

export default events